(function () {
  if (window.__locationMessageInit) return;
  window.__locationMessageInit = true;

  var GEO_PROXY_URL = 'https://ambrosia-geo.juangc-98.workers.dev';

  // localStorage: one geo lookup per visitor per TTL (shared across tabs; stays under plan limits)
  var CACHE_KEY = 'ambrosia_visitor_location_v2';
  var CACHE_TTL = 24 * 60 * 60 * 1000;
  var ANIMATION_MS = 2400;
  var pendingFetch = null;

  function getCachedLocation() {
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.ts > CACHE_TTL) return null;
      return hasUsableLocation(data.location) ? data.location : null;
    } catch (e) {
      return null;
    }
  }

  function setCachedLocation(location) {
    if (!hasUsableLocation(location)) return;
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), location: location }));
    } catch (e) {}
  }

  function hasUsableLocation(location) {
    return !!(location && (location.city || location.region || location.region_code));
  }

  function formatDeliveryDate(days) {
    var d = new Date();
    d.setDate(d.getDate() + parseInt(days, 10));
    return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  // City / state / province only — never country. Null => keep fallback
  function formatLocation(data, type) {
    if (!data) return null;

    var city = data.city;
    var region = data.region || data.region_code;

    switch (type) {
      case 'region':
        return region || null;
      case 'city_region': {
        if (city && region) return city + ', ' + region;
        return city || region || null;
      }
      case 'city':
      case 'country':
      default:
        return city || region || null;
    }
  }

  function normalizeIpwhoPayload(payload) {
    if (!payload || payload.success === false) return null;

    // /me returns flat fields under data; /ip/{ip} may nest under data.geoLocation
    var source = (payload.data && payload.data.geoLocation) || payload.data || payload;
    if (!source) return null;

    return {
      city: source.city || null,
      region: source.region || null,
      region_code: source.regionCode || source.region_code || null
    };
  }

  function fetchVisitorLocation() {
    if (!GEO_PROXY_URL) {
      return Promise.reject(new Error('GEO_PROXY_URL not configured'));
    }

    return fetch(GEO_PROXY_URL, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('geo proxy failed (' + response.status + ')');
        return response.json();
      })
      .then(function (payload) {
        var location = normalizeIpwhoPayload(payload);
        if (!hasUsableLocation(location)) throw new Error('no city/region in geo response');
        return location;
      });
  }

  function applyDeliveryDates() {
    document.querySelectorAll('.location-message__text[data-delivery-days]').forEach(function (el) {
      var days = el.getAttribute('data-delivery-days');
      var dateEl = el.querySelector('.location-message__date');
      if (dateEl && days) dateEl.textContent = formatDeliveryDate(days);
    });
  }

  function applyLocations(locationData) {
    document.querySelectorAll('.location-message__text[data-location-type]').forEach(function (el) {
      var type = el.getAttribute('data-location-type') || 'city';
      var fallback = el.getAttribute('data-fallback-location');
      var placeEl = el.querySelector('.location-message__place');
      if (!placeEl) return;

      var formatted = formatLocation(locationData, type) || fallback;
      if (formatted) placeEl.textContent = formatted;
    });
  }

  function playAnimations() {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.location-message__anim[data-enable-animation="true"]').forEach(function (el) {
      el.classList.remove('is-animating', 'is-complete');

      if (reducedMotion) {
        el.classList.add('is-complete');
        return;
      }

      void el.offsetWidth;
      el.classList.add('is-animating');

      window.setTimeout(function () {
        el.classList.remove('is-animating');
        el.classList.add('is-complete');
      }, ANIMATION_MS);
    });
  }

  function initLocationMessages() {
    if (!document.querySelector('.location-message__text[data-location-type]')) return;

    applyDeliveryDates();
    playAnimations();

    var cached = getCachedLocation();
    if (cached) {
      applyLocations(cached);
      return;
    }

    if (!GEO_PROXY_URL) return;

    if (!pendingFetch) {
      pendingFetch = fetchVisitorLocation()
        .then(function (locationData) {
          setCachedLocation(locationData);
          return locationData;
        })
        .catch(function (err) {
          console.warn('Geolocation lookup failed; keeping fallback location:', err);
          return null;
        })
        .finally(function () {
          pendingFetch = null;
        });
    }

    pendingFetch.then(function (locationData) {
      if (locationData) applyLocations(locationData);
    });
  }

  window.ambrosiaLocation = { init: initLocationMessages };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocationMessages);
  } else {
    initLocationMessages();
  }

  document.addEventListener('shopify:section:load', initLocationMessages);
  document.addEventListener('shopify:block:select', initLocationMessages);
})();
